"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var OnboardingStepIcon_1 = __importDefault(require("components/Icons/OnboardingStepIcon"));
var hooks_1 = require("containers/Onboarding/hooks");
var utils_1 = require("containers/Onboarding/utils");
var analytics_1 = require("utils/analytics");
var single_1 = require("utils/selectors/single");
var stepsDefinitions_1 = require("./stepsDefinitions");
var StepTitle_1 = __importDefault(require("./styles/StepTitle"));
var StepWrapper_1 = __importDefault(require("./styles/StepWrapper"));
var OnboardingStep = function (_a) {
    var stepName = _a.stepName;
    var _b = __read(react_1.default.useState(false), 2), isModalOpen = _b[0], setIsModalOpen = _b[1];
    var track = (0, analytics_1.usePreparedTracker)('Onboarding Step Line Item Clicked');
    var addUserOnbStep = (0, hooks_1.useAddUserOnboardingStep)();
    var addCompanyOnbStep = (0, hooks_1.useAddCompanyOnboardingStep)();
    var profile = (0, react_redux_1.useSelector)(single_1.selectProfile);
    var company = (0, react_redux_1.useSelector)(single_1.selectMyCompany);
    var step = stepsDefinitions_1.STEP_MAPPER[stepName];
    if (!step || !company) {
        return null;
    }
    var StepComponent = step.StepComponent, to = step.to, toWhenDone = step.toWhenDone, stepOwner = step.stepOwner, label = step.label, addStepOnClick = step.addStepOnClick, disabledCondition = step.disabledCondition, ModalComponent = step.ModalComponent;
    var stepAdder = { user: addUserOnbStep, company: addCompanyOnbStep }[stepOwner];
    var isDone = (0, utils_1.stepIsDone)(profile, company)(stepName);
    var isDisabled = disabledCondition === null || disabledCondition === void 0 ? void 0 : disabledCondition(company);
    if (StepComponent) {
        return (0, jsx_runtime_1.jsx)(material_1.ListItem, __assign({ disablePadding: true, sx: { ml: 2 } }, { children: (0, jsx_runtime_1.jsx)(StepComponent, { isDone: isDone }) }));
    }
    return ((0, jsx_runtime_1.jsxs)(material_1.ListItem, __assign({ disableGutters: true, disablePadding: true }, { children: [(0, jsx_runtime_1.jsxs)(StepWrapper_1.default, __assign({ to: (0, utils_1.getTo)(isDone, isDisabled, to, toWhenDone) || '#', onClick: function () {
                    track({ stepName: stepName, isDisabled: isDisabled });
                    if (isDisabled || (!addStepOnClick && !ModalComponent))
                        return null;
                    if (ModalComponent)
                        return setIsModalOpen(true);
                    return stepAdder(stepName);
                }, disabled: isDisabled }, { children: [(0, jsx_runtime_1.jsx)(material_1.Box, __assign({ mr: 4 }, { children: (0, jsx_runtime_1.jsx)(OnboardingStepIcon_1.default, { isDone: isDone }) })), (0, jsx_runtime_1.jsx)(StepTitle_1.default, __assign({ isDisabled: isDisabled, mr: 3 }, { children: label }))] })), ModalComponent && (0, jsx_runtime_1.jsx)(ModalComponent, { open: isModalOpen, onClose: function () { return setIsModalOpen(false); } })] })));
};
exports.default = OnboardingStep;
